<template>
  <div class="contactUs">
    <div class="content_area">
      <div class="title"><span>//</span>联系我们</div>
      <!-- <div class="main">
        <div>
          上海友砾申信息科技有限公司成立于2016年7月，主要专注于国际物流行业的互联网技术、移动互联网技术、云计算、大数据等最前沿IT技术的开发及应用采取“互联网+SAAS软件”模式全面解决物流企业痛点。提成行业效率。公司主要产品:众云通系统(SAAS软件)
        </div>
        <div>
          改变传统运价展示模式。通过线上的数据采集帮助企业精准分析、精准营销，提高效率。
        </div>
        <div>
          公司还牵头组建了国际物流联盟MPA联盟(MultiPlasAlliance)。MPA通过集中营销和集中采购模式，依托彼此之间的数据共享和资源共享，率先在国际物流领域打造了“数字化联盟+生态化联盟”的创新运作模式。
          MPA联盟属于唯一性联盟，每口岸只存在一种业务类型企业。实现资源互补。
        </div>
      </div> -->
      <div class="add_form_box">
        <div class="adress">
          <mapPage :longitude="longitude" :dimension="dimension"></mapPage>
        </div>
        <div class="formbox">
          <div class="ticps">
            如果您在使用本网站时有任何意见或建议，请写下您的意见或者建议。我们会尽快答复您，感谢您的关注~
          </div>
          <div class="name_tel">
            <el-input
              size="small"
              class="input"
              v-model="evaluateVal.name"
              placeholder="名字"
              style="width: 180px"
            />
            <el-input
              size="small"
              class="input1"
              type="number"
              v-model="evaluateVal.phone"
              placeholder="电话"
              style="width: 242px"
            />
          </div>
          <div class="email">
            <el-input
              size="small"
              class="input1"
              v-model="evaluateVal.email"
              placeholder="邮箱"
            />
          </div>
          <div>
            <el-input
              type="textarea"
              class="textarea"
              placeholder="请写下您想说的话"
              v-model="evaluateVal.content"
            />
          </div>
          <div class="btn">
            <el-button
              size="mini"
              type="primary"
              class="submit"
              @click="submit"
              :loading="btnLoading"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { validateTelephone, validateEmail } from "~/baseUtils/validate";
import mapPage from "~/baseComponents/map";
export default {
  components: { mapPage },
  metaInfo: {
    title: "联系我们",
  },
  data() {
    return {
      evaluateVal: {
        name: "",
        email: "",
        phone: "",
        content: "",
      },
      longitude: 121.500782,
      dimension: 31.291941,
      btnLoading: false,
      evaluateRules: {
        phone: {
          validator: async (rule, value, callback) => {
            if (!validateTelephone(value)) {
              this.codeBtnDisabled = true;
              callback("手机号格式错误");
            } else {
            }
          },
          trigger: "blur",
        },
        email: {
          validator: async (rule, value, callback) => {
            if (!validateEmail(value)) {
              this.codeBtnDisabled = true;
              callback("邮箱格式错误");
            } else {
            }
          },
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    async submit() {
      if (!this.IS_LOGIN) {
        this.$GLOBALEVENT.$emit("SHOWGLOBALLOGIN");
        return;
      }
      if (!this.evaluateVal.content) {
        this.$message.warning("输入建议不能为空");
        return;
      }
      this.btnLoading = true;
      this.evaluateVal.source = this.PJSource;
      let res = await this.$store.dispatch(
        "API_index/suggestionSave",
        this.evaluateVal
      );
      this.btnLoading = false;
      if (res.success) {
        this.$message.success("提交成功");
        this.evaluateVal = {};
      } else {
      }
    },
  },
  mounted() {
    console.log("this.PJSource", this.PJSource);
  },
};
</script>
<style lang="less" scoped>
.submit {
  background: #e3954f;
}
.contactUs {
  background: #ffffff;
  .content_area {
    padding: 30px 0 50px;
    .title {
      font-size: 24px;
      margin-bottom: 24px;
      span {
        color: #e3954f;
        margin-right: 10px;
      }
    }
    .main {
      margin: 24px 0;
      div {
        text-indent: 2em;
        line-height: 25px;
      }
    }
    .add_form_box {
      display: flex;
    }
    .adress {
      height: 440px;
      width: 699px;
    }
    .formbox {
      background: rgb(4, 157, 237);
      width: 502px;
      padding: 36px 32px 28px 32px;
      .ticps {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
      }
      .name_tel {
        display: flex;
        justify-content: space-between;
        margin-top: 24px;
      }
      .email {
        margin: 16px 0;
      }
      .btn {
        margin-top: 16px;
        text-align: center;
        button {
          width: 115px;
          height: 30px;
        }
      }
    }
  }

  /deep/.el-textarea__inner {
    min-height: 154px !important;
  }
  /deep/.el-form-item__error {
    color: #d8563a;
    margin-left: 16px;
  }
}
</style>